var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.918a5.084 5.084 0 00-5.082 5.083A5.084 5.084 0 0011 16.082c2.794 0 5.06-2.288 5.06-5.082 0-2.795-2.266-5.083-5.06-5.083zm0 8.954a3.878 3.878 0 01-3.872-3.871A3.878 3.878 0 0111 7.128c2.134 0 3.85 1.738 3.85 3.873 0 2.133-1.716 3.872-3.85 3.872zM16.918 3.586c-.396 0-.77.154-1.034.44-.286.286-.44.638-.44 1.034s.154.77.44 1.034c.286.286.638.44 1.034.44s.77-.154 1.034-.44c.264-.264.44-.638.44-1.034v-.022c0-.374-.176-.748-.44-1.012-.22-.308-.638-.44-1.034-.44z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.742.22H5.258A5.051 5.051 0 00.22 5.258v11.506c0 2.75 2.266 5.016 5.038 5.016h11.506c2.75 0 5.016-2.266 5.016-5.038V5.258A5.051 5.051 0 0016.742.22zm3.828 16.522a3.83 3.83 0 01-3.828 3.828H5.258a3.83 3.83 0 01-3.828-3.828V5.258A3.83 3.83 0 015.258 1.43h11.506a3.83 3.83 0 013.828 3.828v11.484h-.022z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f959bcda.svg";
export { ForwardRef as ReactComponent };